import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import QUICK_BUY_CONSTANTS from '@/js/helper/quick-buy-constants.js'
import COMPARE_CONSTANTS from '@/js/helper/compare-constants.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'

// SSO Permission config fro navigation
// Now also checked for component navigation elements

export default {
  NavigationBikesList: {
    name: FILTER_CONSTANTS.SCOPE.BIKES,
    perm: DP_ROLE.SHOP_BIKES_R.p,
    scope: FILTER_CONSTANTS.SCOPE.BIKES,
  },
  NavigationOutletList: {
    name: FILTER_CONSTANTS.SCOPE.OUTLET,
    perm: DP_ROLE.SHOP_BIKES_R.p,
    scope: FILTER_CONSTANTS.SCOPE.OUTLET,
  },
  NavigationSparePartsList: {
    name: FILTER_CONSTANTS.SCOPE.SERVICE,
    perm: DP_ROLE.SHOP_PARTS_R.p,
    scope: FILTER_CONSTANTS.SCOPE.SERVICE,
  },
  NavigationSparePartsSaleList: {
    name: FILTER_CONSTANTS.SCOPE.PART_SALE,
    perm: DP_ROLE.TYPO3_SALE_L,
    scope: FILTER_CONSTANTS.SCOPE.PART_SALE,
  },
  NavigationAccessoriesList: {
    name: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
    perm: DP_ROLE.SHOP_ACCESSORIES_R.p,
    scope: FILTER_CONSTANTS.SCOPE.ACCESSORIES,
  },
  NavigationArchiveList: {
    name: FILTER_CONSTANTS.SCOPE.ARCHIVE,
    perm: DP_ROLE.SHOP_ARCHIVE_R.p,
    scope: FILTER_CONSTANTS.SCOPE.ARCHIVE,
  },
  NavigationProductsList: {
    name: 'products',
  },
  NavigationMessageCenter: {
    name: FILTER_CONSTANTS.SCOPE.MESSAGE_CENTER,
    perm: DP_ROLE.MESSAGING_ACCESS_R.p,
  },
  NavigationPageContent: {
    name: 'default',
  },
  NavigationQuickBuy: {
    name: QUICK_BUY_CONSTANTS.ROUTES.QUICK_BUY.NAME,
    perm: DP_ROLE.SHOP_ORDER_R.p,
  },
  FavoritesDialog: {
    name: 'favorites',
    perm: DP_ROLE.SHOP_FAVORITES_R.p,
  },
  FavoritesPageButton: {
    name: 'favorites',
    perm: DP_ROLE.SHOP_FAVORITES_R.p,
  },
  NavigationCompareList: {
    name: COMPARE_CONSTANTS.ROUTES.COMPARE.NAME,
    perm: DP_ROLE.SHOP_COMPARE_R.p,
  },
  NavigationWarrantyBattery: {
    name: 'service-warranty-battery',
    perm: DP_ROLE.SERVICE_BATTERY_CHARGER_R.p,
  },
  NavigationCompanyVacation: {
    name: 'NavigationCompanyVacation',
    perm: DP_ROLE.ACCOUNT_COMPANY_HOLIDAYS_R.p,
  },
  NavigationSupportAccess: {
    name: 'NavigationSupportAccess',
    perm: DP_ROLE.ACCOUNT_GRANT_SUPPORT_ACCESS_R.p,
  },
  NavigationOpenItems: {
    name: 'NavigationOpenItems',
    perm: DP_ROLE.ACCOUNT_ACCOUNTING_DOCUMENTS_R.p,
  },
  NavigationClickAndCollect: {
    name: 'NavigationClickAndCollect',
    perm: DP_ROLE.ACCOUNT_ACCOUNTING_DOCUMENTS_R.p,
  },
  NavigationCreditLimit: {
    name: 'NavigationCreditLimit',
    perm: DP_ROLE.ACCOUNT_ACCOUNTING_CREDIT_LIMIT_R.p,
  },
  NavigationMyData: {
    name: 'NavigationMyData',
    perm: DP_ROLE.ACCOUNT_USER_SELF_R.p,
  },
  NavigationPartnerEvents: {
    name: 'event-registration',
    perm: DP_ROLE.ACCOUNT_USER_SELF_W.p,
    storeCheck: store => !!store.getters[`${STOREMODULES.APP}/${APP_GETTERS.EVENT_COUNT}`],
  },
  NavigationWarrantyComponents: {
    name: 'NavigationWarrantyComponents',
    perm: DP_ROLE.SERVICE_SERVICE_WARRANTY_R.p,
  },
  NavigationSerialNumberSearch: {
    name: 'serial-number-search',
    perm: DP_ROLE.SERVICE_SERVICE_WARRANTY_R.p,
  },
  NavigationWarrantyEngine: {
    name: 'NavigationWarrantyEngine',
    perm: DP_ROLE.SERVICE_ENGINE_R.p,
  },
  NavigationWarrantyReturns: {
    name: 'NavigationWarrantyReturns',
    perm: DP_ROLE.SERVICE_PART_DELIVERY_CLAIM_R.p,
  },
  NavigationUsermanagement: {
    name: 'usermanagement',
    perm: DP_ROLE.ACCOUNT_USER_SUBUSER_R.p,
  },
  NavigationDealerList: {
    name: 'dealers',
    perm: DP_ROLE.ACCOUNT_USER_SALES_OFFICE_R.p,
  },
  NavigationConnectedBike: {
    name: 'NavigationConnectedBike',
    perm: DP_ROLE.FEATURE_CONNECTEDBIKES_R.p,
  },
}
